import { performFetch } from './utils'

export function loadDocs() {
    return performFetch({ type: 'LOAD_DOCS' })
}

export function loadDoc(slug) {
    return performFetch({
        type: 'LOAD_SINGLE_DOC',
        urlData: { slug },
    })
}



// WEBPACK FOOTER //
// ./app/actions/docs.js